<youtube-player #ytb videoId="{{structure[index]['url']}}" width="100%" height="100%"></youtube-player>